<style lang="less">
@import "../verificationOriginal/index.less";
</style>
<template>
    <div class="ordercommon">  
        <div class="vmain-content">
            <div class="orderTitleTopStyle">
                <span>版权家可信存证核验</span>
                <img src="../verificationOriginal/images/tittleBottom.png" />
            </div>

            <!-- 证书内容信息 -->
            <div class="orderContentStyle bgImg">
                <div class="orderContent-tip" style="marginBottom:20px">
                    <div class="floatDiv">
                        <img src="../verificationOriginal/images/oneIcon.png" style="verticalAlign:middle"/>
                        <span>证书内容信息</span>
                    </div>
                    <div class="floatDiv" data-num="0" style="float: right; cursor:pointer" @mouseenter="changeImg($event)"  @mouseleave="hideImg">
                        <img src="../verificationOriginal/images/wenhaoYellow.png" style="vertical-align: middle" />
                        <span style="color:#666;font-size:12px">证书内容信息的重要性</span>
                    </div>
                </div>
                <div class="floatInfo" style="top:193px;height:286px" v-if="newBlock">
                    <p>版权家将证书中主要文字内容摘取出来作为证书内容信息，它是证书的主体部分，用以说明证书的申请人和作品之间的关系及版权相关信息。通过SHA256散列函数算法得出证书内容完整性校验值，作为向国家授时中心可信时间服务申请授时凭证的事物编号，以此来保证证书内容信息与授时时间信息相对应。</p>
                </div>
                <div class="orderContent-center" style="margin-bottom: 25px">
                    <div class="spanPosition">
                        <span style="font-weight:600;font-size:14px">证书内容完整性校验值</span>
                        <span style="font-size: 14px;color:#999">（该值由证书中摘取的主要内容通过SHA256算法得出）</span>
                    </div>
                    <div style="margin-bottom: 20px;margin-top:15px">
                        <span id="public_text" class="input-span-styles">{{recodes.tscData}}</span>
                    </div>
                    <div class="spanPosition">
                        <span style="font-weight: 600;font-size:14px">证书中摘取的主要内容</span>
                    </div>
                    <div style="margin-top: 20px">
                        <textarea id="public_text" class="textarea-style" :value="recodes.summary" />
                    </div>
                </div>
                <div style="border-bottom: 1px dashed #efefef"></div>
                <div class="orderContent-tip" style="margin-top:22px;margin-bottom:18px">
                    <div class="floatDiv">
                        <img src="../verificationOriginal/images/book2.png" style="vertical-align: middle" />
                        <span>内容核验</span>
                        <span style="color:red;font-size:12px">*<strong>千万不要</strong>使用火狐浏览器访问，会导致加密错误</span>
                    </div>
                    <div class="floatDiv" data-num="1" style="float: right; cursor:pointer" @mouseenter="changeImg($event)"  @mouseleave="hideImg">
                        <img src="../verificationOriginal/images/wenhaoYellow.png" style="vertical-align: middle" />
                        <span style="color: #666;font-size:12px">为什么要内容核验</span>
                    </div>
                </div>
                <div class="floatInfo" style="top: 790px;left:981px" v-if="newBlock1">
                    <p>内容核验的意义在于，通过在第三方平台，使用SHA256散列函数算法计算证书内容信息的完整性校验值，并与证书内容完整性校验值匹配，来验证证书内容信息的完整和未被篡改。</p>
                </div>
                <div style="overflow:'hidden">
                    <div class="marginLeft60 floatImg">
                        <span class="step-one">step 01</span>
                        <div class="btn-copy-style">复制证书中摘取的主要内容</div>
                        <button class="btn primary btn-120"  
                            v-clipboard:copy="recodes.summary" 
                            v-clipboard:success="onCopy" 
                            v-clipboard:error="onError">点击复制核验内容
                        </button>
                       
                    </div>
                    <div class="floatImg">
                        <span class="step-one">step 02</span>
                        <div class="step-two">
                            <span class="step-three">选择下方任意网址，粘贴已复制好的内容，使用SHA256加密</span>
                            <img src="../verificationOriginal/images/sha34.png" style="float: right"/>
                        </div>
                        <div class="step-four">
                            <a class='hash-link lineHeight16' target="_blank" href="http://www.jsons.cn/sha/">http://www.jsons.cn/sha/</a>
                            <a class='hash-link lineHeight16' target="_blank" href="http://encode.chahuo.com/">http://encode.chahuo.com/</a>
                            <a class='hash-link lineHeight16' target="_blank" href="https://md5file.com/calculator">https://md5file.com/calculator</a>
                            <a class='hash-link lineHeight16' target="_blank" href="https://hash.online-convert.com/sha256-generator">https://hash.online-convert.com/sha256-generator</a>
                        </div>

                    </div>
                    <div class="floatImg2">
                        <span class="step-one">step 03</span>
                        <span class="step-six">得出来的结果与你拥有的证书内容完整性校验值比对，完全一致即表明证书承载的信息没有任何问题。</span>
                    </div>
                </div>
            </div>

             <!-- 互联网法院信息 -->
            <div class="orderContentStyle bgImg2">
                <div class="orderContent-tip" style="margin-bottom:20px">
                    <div class="floatDiv">
                        <img src="../verificationOriginal/images/clock1.png" style="vertical-align: middle" />
                        <span>互联网法院信息</span>
                    </div>
                </div>
                <div style="padding-left: 66px">
                    <span style="font-weight:600;font-size:14px">北京互联网法院-天平链核验</span>
                    <div style="margin:20px 0px 10px">
                        <span class="span-line20">天平链存证编码</span>
                    </div>
                    <div>
                        <span id="public_text" class="input-span-styles">{{tinaPingCode}}</span>
                        <button class="button-copy"  
                            v-clipboard:copy="tinaPingCode" 
                            v-clipboard:success="onCopy" 
                            v-clipboard:error="onError">复制存证编码
                        </button>
                       
                    </div>                  
                    <p style="color: #ff0000;line-height: 18px;margin-bottom: 16px;font-size:12px">注：请复制天平链存证编码，前往北京互联网法院-天平链公示网站进行核验
                    </p>
                </div>
                <div style="border-bottom: 1px dashed #efefef"></div>
                <div class="orderContent-tip" style="margin-top: 22px; margin-bottom: 0px">
                    <div class="floatDiv">
                        <img src="../verificationOriginal/images/clock2.png" style="vertical-align: middle" />
                        <span>天平链核验</span>
                    </div>                  
                </div>              
                <div style="height:18px"></div>
                <div style="text-align:center;padding-bottom:60px" class="astyle">
                    <img src="../verificationOriginal/images/beijingicon.png" style="width:277px;height:48px;margin-bottom:20px;margin-top:13px"/>
                    <a target='_blank' href="http://bc.bjinternetcourt.gov.cn:8888/index.html#/pcSearch"><input type="button" class="input-btn-seck" value="去北京互联网法院官网核验" /></a>                                      
                </div>
            </div>

             <!-- {/* 版权区块链公示信息 */} -->
            <div class="orderContentStyle bgImg4">
                <div class="orderContent-tip" style="margin-bottom: 0px;position:relative">
                    <div class="floatDiv">
                        <img src="../verificationOriginal/images/eightIcon.png" style="vertical-align: middle" />
                        <span>版权区块链公示信息</span>
                    </div>
                    <div class="floatDiv" data-num="6" style="float: right; cursor:pointer" @mouseenter="changeImg($event)"  @mouseleave="hideImg">
                        <img src="../verificationOriginal/images/wenhaoYellow.png" style="vertical-align: middle" />
                        <span style="color: #666;font-size:12px">公示信息的重要性</span>
                    </div>
                </div>
                <div class="floatInfo" style="left: 981px;height: 415px" v-if="newBlock6">
                    <p style="margin: 26px 16px">版权区块链联盟是在全国打击侵犯知识产权和制售假冒伪劣商品工作领导小组办公室的指导下、中国产学研合作促进会反侵权假冒创新战略联盟的支持下，由版权业务相关、拥有独特行业资源的企业或组织等共同组成。联盟使用版权区块链保障信息不可篡改不可伪造，并可自动共识到联盟成员各方，包括司法鉴定中心、律师事务所等法律机构，在版权区块链联盟网站上进行公示信息即是版权信息的宣告，也可由社会各方共同监督保障证书内容信息真实不被篡改。</p>
                </div>
                <div style="padding-left: 69px;margin-top: 20px">
                    <div class="spanPosition">
                        <span style="font-weight:600">公示Hash-电子数据完整性校验值</span>
                        <span style="font-size: 14px; color: #999999">（该值由电子数据内容通过SHA256算法得出）</span>
                        <p style="margin: 10px 0 20px">{{recodes.publicHash}}</p>
                    </div>
                    <div style="margin-bottom:10px">
                        <span class="span-line20" style="font-weight: 600">电子数据内容：</span>
                    </div>
                    <!-- {/* 展开查看全部 */} -->
                        <!-- {/* 签名结果 */} -->
                    <div>
                        <div class="zhankaiBox" style="display:block">
                            <span class="zhankaiSpan">签名结果：{{recodes.caSignResult}}</span>
                            <span class="zhankaispan2"  @click="twolistclick($event)">展开</span>
                        </div>
                        <div class="zhankaiBox2" style="display:none">
                            <span>签名结果：{{recodes.caSignResult}}</span>
                            <p class="closeContent" @click="closelistclick($event)">收起</p>
                        </div>
                    </div>
                        <!-- {/* 用户证书公钥 */} -->
                    <div>
                        <div class="zhankaiBox" style="display:block">
                            <span class="zhankaiSpan">用户证书公钥：{{recodes.caPubKey}}</span>
                            <span class="zhankaispan2" @click="twolistclick($event)">展开</span>
                        </div>
                        <div class="zhankaiBox2" style="display:none">
                            <span>用户证书公钥：{{recodes.caPubKey}}</span>
                            <p class="closeContent" @click="closelistclick($event)">收起</p>
                        </div>
                    </div>
                    <p style="color: #ff0000;line-height: 18px;margin-bottom: 16px;font-size:12px">注：公示Hash在版权区块链联盟网站进行公示
                    </p>
                </div>
                <div style="border-bottom:1px dashed #efefef;margin-top:25px"></div>
                <div class="orderContent-tip" style="margin-top: 22px;margin-bottom: 0px;position:relative;height:32px">
                    <div class="floatDiv">
                        <img src="../verificationOriginal/images/nineIcon.png" style="vertical-align: middle" />
                        <span>公示核验</span>
                    </div>
                    <div class="floatDiv" data-num="7" style="float: right; cursor:pointer" @mouseenter="changeImg($event)"  @mouseleave="hideImg">
                        <img src="../verificationOriginal/images/wenhaoYellow.png" style="vertical-align: middle" />
                        <span style="color: #666;font-size:12px">为什么要公示核验</span>
                    </div>
                </div>
                <div class="floatInfo" style="left: 981px;height:200px" v-if="newBlock7">
                    <p>前往版权区块链联盟网站核验公示信息，就能查看公示Hash是否真实的存在于区块链上和在版权区块链联盟网站上进行了公示。公示Hash由签名结果加上签名公钥经SHA256散列函数算法计算得到。</p>
                </div>
                <p style="margin: 20px 0px 20px 60px;font-weight: 600" >1、公示Hash核验&nbsp;&nbsp;<span style="color: red; font-size: 12px">*<strong>千万不要</strong>使用火狐浏览器访问，会导致加密错误</span></p>
                <div style="overflow: hidden;height:121px">
                    <div class="marginLeft60 floatImg">
                        <span class="step-one">step 01</span>
                        <div class="btn-copy-style">复制证书中摘取的主要内容</div>
                        <button class="btn primary btn-120"  
                            v-clipboard:copy="copyUrls" 
                            v-clipboard:success="onCopy" 
                            v-clipboard:error="onError">点击复制核验内容
                        </button>
                        <!-- {
                            primitiveTscCaData &&
                            <CopyToClipboard onCopy={this.textCopy} text={`${primitiveTscCaData}\n`}>
                                <button class="btn primary" style={{ width: '120px', height: '30px', position: 'absolute', top: '65px', left: '107px', fontSize: '13px',padding:'0' }} @click={()=>this.copyUrl()}>点击复制核验内容</button>
                            </CopyToClipboard>
                        } -->
                    </div>
                    <div class="floatImg">
                        <span class="step-one">step 02</span>
                        <div class="step-two">
                            <span class="step-three">选择下方任意网址，粘贴已复制好的内容，使用SHA256加密</span>
                            <img src="../verificationOriginal/images/sha34.png" style="float: right"/>
                        </div>
                        <div class="step-four">
                            <a class='hash-link lineHeight16' target="_blank" href="http://www.jsons.cn/sha/">http://www.jsons.cn/sha/</a>
                            <a class='hash-link lineHeight16' target="_blank" href="http://encode.chahuo.com/">http://encode.chahuo.com/</a>
                            <a class='hash-link lineHeight16' target="_blank" href="https://md5file.com/calculator">https://md5file.com/calculator</a>
                            <a class='hash-link lineHeight16' target="_blank" href="https://hash.online-convert.com/sha256-generator">https://hash.online-convert.com/sha256-generator</a>
                        </div>

                    </div>
                    <div class="floatImg2">
                        <span class="step-one">step 03</span>
                        <span class="step-six">得出来的结果与你拥有的证书内容完整性校验值比对，完全一致即表明证书承载的信息没有任何问题。</span>
                    </div>
                </div>
                <p style="margin: 25px 0 15px 60px; font-weight:600" >2、公示信息核验</p>
                <div style="text-align: center;padding-bottom:60px">
                    <img src="../verificationOriginal/images/tenIcon.png" style="margin-bottom: 20px;margin-top: 13px" />
                    <a class="input-btn-seck" target="_blank" :href="herfUrl">去版权区块链联盟核验</a>
                </div>
            </div>

            <!--  签名信息  -->
            <div class="orderContentStyle bgImg3">
                <div class="orderContent-tip" style="margin-bottom: 0px">
                    <div class="floatDiv">
                        <img src="../verificationOriginal/images/fontIcon.png" style="vertical-align: middle" />
                        <span>签名信息</span>
                    </div>
                    <div class="floatDiv" data-num="4" style="float: right; cursor:pointer" @mouseenter="changeImg($event)"  @mouseleave="hideImg">
                        <img src="../verificationOriginal/images/wenhaoYellow.png" style="vertical-align: middle" />
                        <span style="color: #666;font-size:12px">数字签名的重要性</span>
                    </div>
                </div>
                <div class="floatInfo" style="left: 981px;height:314px" v-if="newBlock4">
                    <p>版权家使用天威诚信颁发的数字证书，对证书内容完整性校验值（事务编号）、授时时间、授时凭证加密后进行签名，生成签名结果，来确保签名人认可签名内容的真实性。北京天威诚信电子商务服务有限公司是经工业和信息化部许可的电子认证服务机构，提供制作、签发、管理电子签名认证证书服务，并且可确认签发的电子签名真实性。</p>
                </div>
                <div style="height:20px"></div>
                <div style="padding-left: 69px">
                    <div style="margin-bottom: 5px">
                        <span class="span-line20">数字证书持有人：</span>
                        <span style="line-height: 20px" class="word-warp-span">{{recodes.caUser}}</span>
                    </div>
                    <div style="margin-bottom: 10px">
                        <span lass="span-line20">证书签发机构：</span>
                        <span style="line-height: 20px" class="word-warp-span">{{recodes.caOrganization}}</span>
                    </div>
                    <!-- {/* 展开查看全部 */} -->
                        <!-- {/* 签名原文 */} -->
                    <div>
                        <div class="zhankaiBox" style="display:block">
                            <span class="zhankaiSpan">签名原文：{{recodes.callBackCaRequestData}}</span>
                            <span class="zhankaispan2" @click="newslistclick($event)">展开</span>
                        </div>
                        <div class="zhankaiBox2" style="display:none">
                            <span>签名原文：{{recodes.callBackCaRequestData}}</span>
                            <p class="closeContent" @click="closelistclick($event)">收起</p>
                        </div>
                    </div>
                        <!-- {/* 用户证书公钥 */} -->
                    <div>
                        <div class="zhankaiBox" style="display:block">
                            <span class="zhankaiSpan">用户证书公钥：{{recodes.caPubKey}}</span>
                            <span class="zhankaispan2"  @click="newslistclick($event)">展开</span>
                        </div>
                        <div class="zhankaiBox2" style="display:none">
                            <span>用户证书公钥：{{recodes.caPubKey}}</span>
                            <p class="closeContent" @click="closelistclick($event)">收起</p>
                        </div>
                    </div>
                        <!-- {/* 签名结果 */} -->
                    <div>
                        <div class="zhankaiBox" style="display:block">
                            <span class="zhankaiSpan">签名结果：{{recodes.caSignResult}}</span>
                            <span class="zhankaispan2" @click="newslistclick($event)">展开</span>
                        </div>
                        <div class="zhankaiBox2" style="display:none">
                            <span >签名结果：{{recodes.caSignResult}}</span>
                            <p class="closeContent" @click="closelistclick($event)">收起</p>
                        </div>
                    </div>
                </div>
                <div style="border-bottom:1px dashed #efefef;margin-top:25px"></div>
                 <div class="orderContent-tip" style="margin-top: 22px;margin-bottom: 0px;position:relative">
                    <div class="floatDiv">
                        <img src="../verificationOriginal/images/fiveIcon.png" style="vertical-align: middle" />
                        <span>签名核验</span>
                    </div>
                    <div class="floatDiv" data-num="5" style="float: right; cursor:pointer" @mouseenter="changeImg($event)"  @mouseleave="hideImg">
                        <img src="../verificationOriginal/images/wenhaoYellow.png" style="vertical-align: middle" />
                        <span style="color: #666;font-size:12px">为什么要签名核验</span>
                    </div>
                </div>
                <div class="floatInfo" style="left: 981px;height:200px" v-if="newBlock5">
                    <p>通过访问天威诚信提供的数字证书签名核验页面，将签名原文、签名结果、签名公钥输入后即可进行核验。核验成功即可查看所有加密后的信息，以此来保证签名人认可签名的信息，签名信息不被伪造。</p>
                </div>
                <div style="text-align: center;padding-bottom: 60px;margin-top:20px" class="astyle">
                    <img src="../verificationOriginal/images/sixIcon.png" style="margin-bottom: 20px; margin-top: 13px" />
                    <!-- {
                        window.location.origin == "http://devv.bqj.cn" || window.location.origin == "http://testv.bqj.cn" || window.location.origin == "http://localhost:8080" ? -->
                            <div>
                                <form method="post" action="https://www.itrusign.com/esp/cert/verifyAct" target="_blank">
                                    <input type="hidden" name="caData" :value="recodes.callBackCaRequestData" readOnly={true} />
                                    <input type="hidden" name="caSignedMsg" :value="recodes.caSignResult" readOnly={true} />
                                    <input type="hidden" name="caPubKey" :value="recodes.caPubKey" readOnly={true} />
                                    <input type="submit" class="input-btn-seck" value="去天威诚信官网核验" />
                                </form>
                            </div>
                            <!-- :
                            <div>
                                <form method="post" action="https://www.itrusign.com/esp/cert/verifyAct" target="_blank">
                                    <input type="hidden" name="caData" :value="recodes.callBackCaRequestData" readOnly={true} />
                                    <input type="hidden" name="caSignedMsg" :value="recodes.caSignResult" readOnly={true} />
                                    <input type="hidden" name="caPubKey" :value="recodes.caPubKey" readOnly={true} />
                                    <input type="submit" class="input-btn-seck" value="去天威诚信官网核验" />
                                </form>
                            </div> -->
                    <!-- } -->
                </div>
            </div>

            <!-- 授时时间信息 -->
            <div class="orderContentStyle bgImg2">
                <div class="orderContent-tip" style="margin-bottom:0px">
                    <div class="floatDiv">
                        <img src="../verificationOriginal/images/clock1.png" style="vertical-align: middle" />
                        <span>授时时间信息</span>
                    </div>
                    <div class="floatDiv" data-num="2" style="float: right; cursor:pointer"  @mouseenter="changeImg($event)"  @mouseleave="hideImg">
                        <img src="../verificationOriginal/images/wenhaoYellow.png" style="vertical-align: middle" />
                        <span style="color: #666;font-size:12px">可信授时的重要性</span>
                    </div>
                </div>
                <div class="floatInfo" style="left:982px;height:228px" v-if="newBlock2">
                    <p>法律中的很多规定，都以时间作为事实依据，然而创作者或者版权家都很难自证采用的时间是真实和有法律效用的。中国科学院国家授时中心负责中国标准时间的产生、保持和发播，提供可信授时服务，可以作为时间真实性和有效性的权威证据。</p>
                </div>
                <div style="padding-left: 66px;margin-top:20px;">
                    <div style="margin-bottom: 5px">
                        <span class="span-line20">证书的授时时间：</span>
                        <span class="word-warp-span">{{recodes.tscTime}}</span>
                    </div>
                    <div style="margin-bottom: 5px">
                        <span class="span-line20">授时凭证编号：</span>
                        <span class="word-warp-span">{{recodes.tscVoucherNum}}</span>
                    </div>
                    <div style="margin-bottom: 8px">
                        <span class="span-line20">事物编号：</span>
                        <span class="word-warp-span">{{recodes.tscData}}</span>
                    </div>                   
                    <div style="margin-bottom: 8px">
                        <span class="span-line20">凭证字符串：</span>
                        <span class="tsc-span">{{recodes.tscCtsr}}</span>
                    </div>                   
                    <p style="color: #ff0000;line-height: 18px;margin-bottom: 16px;font-size:12px">注：授时时间由中国科学院国家授时中心可信时间服务提供授时
                    </p>
                </div>
                <div style="border-bottom: 1px dashed #efefef"></div>
                <div class="orderContent-tip" style="margin-top: 22px; margin-bottom: 0px">
                    <div class="floatDiv">
                        <img src="../verificationOriginal/images/clock2.png" style="vertical-align: middle" />
                        <span>授时时间核验</span>
                    </div>
                    <div class="floatDiv" data-num="3" style="float: right; cursor:pointer" @mouseenter="changeImg($event)"  @mouseleave="hideImg">
                        <img src="../verificationOriginal/images/wenhaoYellow.png" style="vertical-align: middle" />
                        <span style="color: #666;font-size:12px">为什么要授时时间核验</span>
                    </div>
                </div>
                <div class="floatInfo" style="left: 957px;height:285px" v-if="newBlock3">
                    <p>版权家将证书内容完整性校验值作为事物编号，将信息传递给中国科学院国家授时中心可信时间服务，获得授时时间和授时凭证，以保证证书中采用的时间是精准和有效的时间。该时间可在中国科学院国家授时中心可信时间服务平台网站，通过事物编号、授时时间和授时凭证进行核验，以保证时间的精确和不可伪造。</p>
                </div>
                <div style="height:18px"></div>
                <div style="text-align:center;padding-bottom:60px" class="astyle">
                    <img src="../verificationOriginal/images/twoIcon.png" style="margin-bottom:20px;margin-top:13px"/>
                    <a target='_blank' href="https://ttas.ntsc.ac.cn/"><input type="button" class="input-btn-seck" value="去可信时间服务网站核验" /></a>
                    
                    <!-- 有一部分代码暂时删除（链接） -->
                </div>
            </div>

        </div>
    </div>
    
</template>

<script>
import {_getVerifyOperatio,_getTianPing} from '../../../api/evidence.js';
import $ from 'jquery';
export default {
    metaInfo: {
        title: '版权家可信存证核验|时尚知识产权保护平台',
        meta: [{                 // set meta
            name: 'keyWords',
            content: ''
        },{
            name: 'Description',
            content: ''
        }]
    },
    name:'verificationPublic',
    data() {
        return {
            newBlock:false,
            newBlock1: false,
            newBlock2: false,
            newBlock3: false,
            newBlock4: false,
            newBlock5: false,
            newBlock6: false,
            newBlock7: false, 
            recodes:"",
            herfUrl:"",
            copyUrls:"",
            tinaPingCode:""
        }
    },
    methods: {
        //显示或隐藏 具体使用方式
        changeImg(event) {
            event.stopPropagation();
            const num = event.currentTarget.getAttribute("data-num");
            switch (num) {
                case "0":
                    this.newBlock=true
                    break;
                case "1":
                    this.newBlock1=  true
                    break;
                case "2":
                    this.newBlock2=  true
                    break;
                case "3":
                    this.newBlock3=  true
                    break;
                case "4":
                   this.newBlock4=  true
                    break;
                case "5":
                    this.newBlock5=  true
                    break;
                case "6":
                   this.newBlock6=  true
                    break;
                case "7":
                   this.newBlock7=  true
                    break;
            }
        },
        hideImg(){         
            this.newBlock= false;
            this.newBlock1= false;
            this.newBlock2= false;
            this.newBlock3= false;
            this.newBlock4= false;
            this.newBlock5=false;
            this.newBlock6= false;
            this.newBlock7= false;
            
        },
        //获取核验
        getVerifyOperatio(){
            const data={
                businessType:this.$route.params.type,
                orderSeqNo:this.$route.params.id
            }
            _getVerifyOperatio(data).then(res => {
                if(res.code==200){
                   this.recodes=res.result;
                   this.herfUrl= this.API_ROOT_UPLOAD + 'bqjvip/verifyOperation/cbca/'+res.result.publicHash;
                   this.copyUrls='签名结果'+res.result.caSignResult+`\n`+'用户证书公钥'+res.result.caPubKey;
                   this.getTianPing(res.result.publicHash);
                }else{
                    toast(res.message)
                }                                                   
            });
        },
        //获取天平链数据
        getTianPing(val){
            _getTianPing({pulicHash:val}).then((res)=>{
                if(res.code==200){
                    this.tinaPingCode=res.result.data.txid0
                }else{
                    toast(res.message)
                } 
            })
        },
        //收起
        closelistclick(e){
            $(e.currentTarget).parents().siblings(".zhankaiBox").css("display", "block");
            $(e.currentTarget).parents(".zhankaiBox2").css("display", "none");
        },
        //展开
        newslistclick(e){
            $(e.currentTarget).parents(".zhankaiBox").css("display","none");
            $(e.currentTarget).parents().siblings(".zhankaiBox2").css("display", "block");
            $(e.currentTarget).parents().parent().siblings().children(".zhankaiBox2").css("display", "none");
            $(e.currentTarget).parents().parent().siblings().children(".zhankaiBox").css("display", "block");
        },
        twolistclick(e){
            $(e.currentTarget).parents(".zhankaiBox").css("display", "none");
            $(e.currentTarget).parents().siblings(".zhankaiBox2").css("display", "block");
            $(e.currentTarget).parents().parent().siblings().children(".zhankaiBox2").css("display", "none");
            $(e.currentTarget).parents().parent().siblings().children(".zhankaiBox").css("display", "block");
        },
        //复制
        onCopy(e) {
            toast("复制成功");
        },
        onError(e) {
            toast("复制失败");
        }

    },
    mounted() {
        this.getVerifyOperatio()
    },
}
</script>